
import './App.css';
import React, {useState,useEffect} from 'react';


import AppLaunch from './AppLaunch';

function App() {

  useEffect(() => {
    document.title = "RestoHandle"
 }, []); 

  return (
    <div className="App">
      <AppLaunch />
    </div>
  );
}

export default App;
